import { SerializedIncomingEmail } from './email-service';
import { MailOfferReviewStatus } from './mailOfferReview';

export type EmailSource = 'tenant' | 'user' | '';

export const ScannedEmailFields: Record<keyof (SerializedIncomingEmail & { mailOfferReviewStatus?: MailOfferReviewStatus }), string> = {
  matchingNegotiationId: 'matchingNegotiationId',
  plainPart: 'plainPart',
  inlineImages: 'inlineImages',
  attachedPdfs: 'attachedPdfs',
  attachedXlsx: 'attachedXlsx',
  attachedCsv: 'attachedCsv',
  inReplyTo: 'inReplyTo',
  reference: 'reference',
  messageId: 'messageId',
  messageSubject: 'messageSubject',
  from: 'from',
  uid: 'uid',
  mailOfferReviewStatus: 'mailOfferReviewStatus',
} as const;
